// extracted by mini-css-extract-plugin
export default {"modalThanksContainer":"modalThanksContainer__J3TbR","text":"text__G-PbT","modalRateContainer":"modalRateContainer__sqVLv","button":"button__D5dr5"};